import { Button, Modal, Label, TextInput, Textarea } from "flowbite-react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Group } from "@/sharedTypes";
import { useEffect } from "react";

interface GroupFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: SubmitHandler<Group>;
  errorMessage?: string;
}

export default function GroupFormDialog({
  open,
  onClose,
  onSubmit,
  errorMessage,
}: GroupFormDialogProps) {
  const { t } = useTranslation(["category"]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<Group>();

  useEffect(() => {
    if (open) {
      reset();
    }
  }, [open, reset]);

  return (
    <Modal show={open} onClose={onClose}>
      <Modal.Header>{t("category:createGroup")}</Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <div className="mb-2 block">
              <Label htmlFor="group_name" value={t("category:groupName")} />
            </div>
            <TextInput
              id="group_name"
              placeholder={t("category:enterGroupName")}
              {...register("group_name", { required: t("category:groupNameRequired") })}
              color={errors.group_name ? "failure" : "gray"}
              helperText={errors.group_name?.message}
            />
          </div>
          <div>
            <div className="mb-2 block">
              <Label htmlFor="group_description" value={t("category:groupDescription")} />
            </div>
            <Textarea
              id="group_description"
              placeholder={t("category:enterGroupDescription")}
              {...register("group_description", {
                required: t("category:groupDescriptionRequired"),
              })}
              color={errors.group_description ? "failure" : "gray"}
              helperText={errors.group_description?.message}
            />
          </div>
          {errorMessage && (
            <div className="text-sm text-red-500">{errorMessage}</div>
          )}
          <div className="flex justify-end gap-2">
            <Button color="gray" onClick={onClose}>
              {t("category:cancel")}
            </Button>
            <Button type="submit" isProcessing={isSubmitting}>
              {t("category:createGroup")}
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
